import { FC, useMemo, ReactNode } from 'react'
import { FloatingPaneHeader } from 'components/features/pfm/FloatingPaneHeader/FloatingPaneHeader'
import { FloatingPaneFooter } from 'components/features/pfm/FloatingPaneFooter/FloatingPaneFooter'
import { FloatingPaneLayout } from 'components/features/pfm/FloatingPaneLayout/FloatingPaneLayout'
import styles from 'components/features/coaching/advisorMeeting/AdvisorRequestPanePreset/AdvisorRequestPanePreset.styl'
import { ButtonTheme } from 'components/features/pfm/Button/Button'

type AdvisorRequestPanePresetProps = {
  title: string
  subTitle?: string
  isLoading?: boolean
  actionName?: string
  actionTheme?: ButtonTheme
  secondaryButton?: ReactNode | null
  cancelName?: string
  cancelTheme?: ButtonTheme
  actionDisabled?: boolean
  notification?: ReactNode
  progressBarPercent?: number
  iconSlug?: string
  onCancel?: () => void
  onFooterCancel?: (() => void) | null
  onSuccess?: () => void
}
export const AdvisorRequestPanePreset: FC<AdvisorRequestPanePresetProps> = (props) => {
  const {
    actionName,
    actionTheme,
    cancelName,
    cancelTheme,
    onCancel,
    onFooterCancel,
    progressBarPercent,
    isLoading,
    onSuccess,
    children,
    notification,
    actionDisabled,
    title,
    subTitle,
    iconSlug,
    secondaryButton,
  } = props

  const headerChild = useMemo(() => (
    <FloatingPaneHeader
      title={ title }
      subTitle={ subTitle }
      iconSlug={ iconSlug }
      progressBarPercent={ progressBarPercent }
      onClose={ onCancel }
      isLoading={ isLoading }
      theme='premium'
      compact
    />
  ), [title, progressBarPercent, iconSlug, subTitle, onCancel, isLoading])

  const footerChild = useMemo(() => {

    return (
      <FloatingPaneFooter
        isLoading={ isLoading }
        actionName={ actionName }
        actionTheme={ actionTheme }
        actionDisabled={ actionDisabled }
        cancelName={ cancelName }
        secondaryButton={ secondaryButton }
        onAction={ onSuccess }
        onCancel={ onFooterCancel !== undefined ? onFooterCancel : onCancel }
        cancelTheme={ cancelTheme }
      />
    )
  }, [onSuccess, isLoading, onCancel, onFooterCancel, actionName, secondaryButton, actionTheme, actionDisabled, cancelTheme, cancelName])

  return (
    <FloatingPaneLayout
      type='advisor'
      header={ headerChild }
      notification={ notification }
      bodyClassName={ styles.advisorRequestPanePreset }
    >
      <div className={ styles.content }>
        { children }
        { footerChild }
      </div>
    </FloatingPaneLayout>
  )
}
